import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { getPostLoginPath, isExternalUser } from "../../utils/roleUtils";

const ExternalLandingRoute = ({ children }) => {
  const location = useLocation();
  const { userData, loading } = useUser();

  if (loading && !userData?.id) {
    return null;
  }

  if (!userData?.id) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isExternalUser(userData)) {
    return <Navigate to={getPostLoginPath(userData.roles)} replace />;
  }

  return children;
};

export default ExternalLandingRoute;
